import { Magazine } from '../../magazineCollection/variants/Magazine';
import type { KeyVisualVariantProps } from '../types';
import type { MagazineNode } from 'data-layer';

/**
 * KeyVisualMagazine component - Magazine variant for KeyVisual.
 *
 * Renders the Magazine-style key visual layout using the Magazine component.
 * The keyVisual prop is actually a MagazineNode when keyVisualType is 'MagazineKeyVisual',
 * as the transformation is handled by MagazineTransformer in the data-layer.
 *
 * @param props - KeyVisual variant component properties
 * @returns Rendered magazine-style key visual variant
 *
 * @example
 * <KeyVisualMagazine
 *   keyVisual={magazineNode} // Already transformed by MagazineTransformer
 *   device="desktop"
 *   awards={[]}
 * />
 */
export function KeyVisualMagazine(props: KeyVisualVariantProps) {
  const { keyVisual, device } = props;

  return (
    <Magazine className="key-visual__magazine" {...(keyVisual as MagazineNode)} device={device} isUsedAsKeyVisual />
  );
}
